<template lang="html">
  <boxwrap class="sound--inner">
    <toolbar>
    </toolbar>
    <boxwrap-contents>
      <div class="sound">
        <div class="sound-tabs">
          <div
            class="sound-tabs__item"
            :class="{ 'is-active' : $route.params.tab === 'admin' }"
          >
            <router-link :to="'/sound/admin'"></router-link>
            <span>Sound Admin</span>
          </div>
          <div
            class="sound-tabs__item"
            :class="{ 'is-active' : $route.params.tab === 'client' }"
          >
            <router-link :to="'/sound/client'"></router-link>
            <span>Sound Client</span>
          </div>
        </div>
        <div class="sound-content">
          <div class="sound-content__item"
            v-if="$route.params.tab === 'admin'"
          >
            <tbl
              :scrollable="true"
            >
              <tbl-inner>
                <tbl-head>
                  <tbl-row>
                    <tbl-td
                      name="name"
                    >
                      name
                    </tbl-td>
                    <tbl-td
                      name="sound-path"
                    >
                      Sound path
                    </tbl-td>
                    <tbl-td
                      name="duration"
                    >
                      duration
                    </tbl-td>
                    <tbl-td
                      name="status"
                    >
                      status
                    </tbl-td>
                    <tbl-td
                      name="actions"
                    >
                      actions
                    </tbl-td>
                  </tbl-row>
                </tbl-head>
                <tbl-body>
                  <tbl-row
                    v-for="(sound, i) in sounds_admin"
                    :key="i"
                  >
                    <tbl-td
                      name="name"
                    >
                      {{ sound.name }}
                    </tbl-td>
                    <tbl-td
                      name="sound-path"
                    >
                      <button class="btn--default">
                        <i class="ico--play"></i>
                      </button>
                      <span>{{ sound.sound_path }}</span>
                    </tbl-td>
                    <tbl-td
                      name="duration"
                    >
                      {{sound.duration}}s
                    </tbl-td>
                    <tbl-td
                      name="status"
                    >
                    <checkbox
                      type="toggle"
                      :class="{'-active': !sound.is_enable}"
                      toggleA="enabled"
                      toggleB="disabled"
                      @click.native.stop.prevent="toggleEnabled(sound)"
                    >
                      <input
                        type="checkbox"
                        v-model="sound.is_enable"
                      />
                    </checkbox>
                    </tbl-td>
                    <tbl-td
                      name="actions"
                    >
                      <button class="btn--modify">
                        <i class="ico--save"></i>
                      </button>
                    </tbl-td>
                  </tbl-row>
                </tbl-body>
              </tbl-inner>
            </tbl>
          </div>
          <div class="sound-content__item"
            v-if="$route.params.tab === 'client'"
          >
            <tbl
              :scrollable="true"
            >
              <tbl-inner>
                <tbl-head>
                  <tbl-row>
                    <tbl-td
                      name="name"
                    >
                      name
                    </tbl-td>
                    <tbl-td
                      name="sound-path"
                    >
                      Sound path
                    </tbl-td>
                    <tbl-td
                      name="duration"
                    >
                      duration
                    </tbl-td>
                    <tbl-td
                      name="status"
                    >
                      status
                    </tbl-td>
                    <tbl-td
                      name="actions"
                    >
                      actions
                    </tbl-td>
                  </tbl-row>
                </tbl-head>
                <tbl-body>
                  <tbl-row
                    v-for="(sound, i) in sounds_client"
                    :key="i"
                  >
                    <tbl-td
                      name="name"
                    >
                      {{ sound.name }}
                    </tbl-td>
                    <tbl-td
                      name="sound-path"
                    >
                      <button class="btn--default">
                        <i class="ico--play"></i>
                      </button>
                      <span>{{ sound.sound_path }}</span>
                    </tbl-td>
                    <tbl-td
                      name="duration"
                    >
                      {{sound.duration}}s
                    </tbl-td>
                    <tbl-td
                      name="status"
                    >
                    <checkbox
                      type="toggle"
                      :class="{'-active': !sound.is_enable}"
                      toggleA="enabled"
                      toggleB="disabled"
                      @click.native.stop.prevent="toggleEnabled(sound)"
                    >
                      <input
                        type="checkbox"
                        v-model="sound.is_enable"
                      />
                    </checkbox>
                    </tbl-td>
                    <tbl-td
                      name="actions"
                    >
                      <button class="btn--modify">
                        <i class="ico--save"></i>
                      </button>
                    </tbl-td>
                  </tbl-row>
                </tbl-body>
              </tbl-inner>
            </tbl>
          </div>
        </div>
      </div>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import Checkbox from '@/components/base/Checkbox'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'

export default {
  name: 'sound',

  components: {
    Checkbox
  },

  mixins: [
    swal
  ],

  data () {
    return {
      sounds_admin: [
        {
          name: 'Cash in',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: true
        },
        {
          name: 'Cash out',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: true
        },
        {
          name: 'Help',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'New User',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'New Bet',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'New Board',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        }
      ],

      sounds_client: [
        {
          name: 'Cash in',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: true
        },
        {
          name: 'Cash out',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'Help',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: true
        },
        {
          name: 'New User',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'New Bet',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        },
        {
          name: 'New Board',
          sound_path: 'sample.mp3',
          duration: '30',
          is_enable: false
        }
      ]
    }
  },

  computed: {

  },

  watch: {

  },

  methods: {
    toggleEnabled (sounds) {
      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, async () => {
        sounds.is_disable = !sounds.is_disable
      }, 'Modify')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
